function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#D500F9;}\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "XMLID_1647_"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1676_",
  className: "st0",
  d: "M439.7,354.7c19.1-19.1,19.1-50.3,0-69.5c-19.1-19.1-50.3-19.1-69.5,0 c-19.1,19.1-19.1,50.3,0,69.5C389.4,373.9,420.6,373.9,439.7,354.7z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1684_",
  className: "st0",
  d: "M405,0C229.1,0,85.4,143.4,85,319.3c-0.1,29.9,4,58.8,11.6,86.3 c15.8,57.2,87.3,76.2,129.2,34.3l0,0c-6.1,0.3-12.2,1.6-17.9,3.8c-1.9,0.7-4,0.8-5.8,0.1c-2.9-1.2-4.6-4-4.5-7 c0.5-22.9,9.8-44.4,25.9-60.6c16.5-16.5,38.5-25.8,61.9-26c3.7,0,7.4,0.2,11,0.6c4.8-11.4,9.9-22.5,15.5-33.2 c-15-1.5-30.2,0.2-44.5,5c-2.4,0.8-5,0.8-7.3-0.3c-3.9-1.8-5.9-6.1-5.1-10.1c4.5-23.4,15.7-44.7,32.7-61.7 c13.5-13.5,29.5-23.3,47.5-29.1c16.2-5.2,33.7-6.9,50.7-4.8c84.6-80.9,198-104.1,220.1-107.9c3-0.5,6,0.4,8.1,2.6l0,0 c2.1,2.1,3.1,5.2,2.6,8.1c-3.8,22-27,135.2-107.6,219.8c2,16.9,0.3,34.3-5,50.4c-5.8,17.9-15.6,33.8-29,47.3 c-16.8,16.8-38,28.1-61.2,32.6c-3.1,0.6-7.4-0.8-9.4-3.2c-2-2.5-2.6-5.7-1.6-8.8c4.8-14.1,6.6-29.2,5.2-44.1 c-10.9,5.6-22.2,10.9-33.8,15.7c0.4,3.5,0.6,7,0.6,10.6c-0.2,23.4-9.4,45.4-26,61.9c-16.2,16.2-37.6,25.4-60.5,25.9 c-2,0.1-4-0.6-5.4-2c-2.2-2.1-2.9-5.3-1.8-8.1c2.3-5.8,3.6-12,3.9-18.2l0,0c-41.9,41.9-22.9,113.4,34.3,129.2 c27.5,7.6,56.4,11.6,86.3,11.6C581.6,639.6,725,495.9,725,320C725,143.3,581.7,0,405,0z"
}));

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 810 640",
    style: {
      enableBackground: "new 0 0 810 640"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e3a4e36e.svg";
export { ForwardRef as ReactComponent };